import React from "react";
import { Helmet } from "react-helmet";

const MetaDecorator = ({ metaTitle, metaDesc, canonicalLink, ogImg }) => {
  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={canonicalLink}></link>
      {process.env.REACT_APP_APP_MODE === "production" ? (
        <meta name="robots" content="index, follow" />
      ) : (
        <meta name="robots" content="noindex" />
      )}

      <meta property="og:url" content={canonicalLink} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDesc} />
      {ogImg ? (
        <meta property="og:image" content={ogImg} />
      ) : (
        <meta
          property="og:image"
          content="https://tastemasters.everestfoods.com/logo-meta-image.png"
        />
      )}
    </Helmet>
  );
};

export default MetaDecorator;
